document.addEventListener("alpine:init", () => {
    Alpine.data("caseStudyGrid", () => ({
        gridFormat: null,
        showFilters: false,
        openFilter: null,
        searchValue: null,
        searchForm: null,
        isLoading: false,
        currentFilters: {},
        postGrid: null,
        filterPrefix: {
            taxonomy: "filter-t-",
            meta: "filter-m-",
            search: "",
            filterMin: "filter-min",
            filterMax: "filter-max",
        },
        updateHistory: true,
        min_area: 10,
        max_area: 1000,
        area_changed: false,
        currentLocations: "",
        sizeForm: null,
        mobileSizeForm: null,
        activeMinSize: null,
        activeMaxSize: null,
        init() {
            this.postGrid = this.$el;
            this.currentFilters = this.getCurrentFilters();

            let shouldFetch = true;
            window.addEventListener("map-locations-updated", (e) => {
                this.currentLocations = e.detail.locations;
                if (shouldFetch) {
                    this.fetchContent(false);
                }
                shouldFetch = false;

                setTimeout(() => {
                    shouldFetch = true;
                }, 1000);
            });

            window.locationComponent = this;

            this.searchForm = this.$refs.searchContainer;
            this.sizeForm = this.$refs.rangeForm;
            this.mobileSizeForm = this.$refs.mobileRangeForm;

            window.innerWidth <= 992 ? this.gridFormat = 'grid' : this.gridFormat = 'list';

            if (this.searchForm || this.sizeForm || this.mobileSizeForm) {
                this.eventListeners();
            }
        },

        eventListeners() {
            this.searchForm.addEventListener("submit", (e) => {
                e.preventDefault();
                if (this.$refs.searchField.value.length) {
                    this.currentFilters.search = this.$refs.searchField.value;
                }
                this.filtering = true;
                this.fetchContent();
            });
        },

        /**
         * setProjectSize
         *
         * Description: Set project size
         *
         * @param {string} minSize
         * @param {string} maxSize
         */
        setProjectSize(minSize, maxSize) {
            if (this.activeMinSize === minSize && this.activeMaxSize === maxSize) {
                // If both are active, clear the filters
                this.activeMinSize = null;
                this.activeMaxSize = null;
                delete this.currentFilters.filterMin;
                delete this.currentFilters.filterMax;
            } else {
                // Set the filter if it's not already active
                this.activeMinSize = minSize;
                this.activeMaxSize = maxSize;

                if (minSize) {
                    this.currentFilters.filterMin = minSize;
                } else {
                    delete this.currentFilters.filterMin;
                }
        
                if (maxSize) {
                    this.currentFilters.filterMax = maxSize;
                } else {
                    delete this.currentFilters.filterMax;
                }
            }
        
            this.filtering = true;
            this.fetchContent();
        },

        /**
         * sizeFilterIsActive
         *
         * Description: Checks if a given filter is currently selected.
         *
         * @param {string} minSize
         * @param {string} maxSize
         * @return {boolean}
         */
        sizeFilterIsActive(minSize, maxSize) {
            return this.activeMinSize === minSize && this.activeMaxSize === maxSize;
        },

        getTotalFilterCount() {
            let total = 0;

            Object.keys(this.currentFilters).forEach((filter) => {
                total += this.currentFilters[filter].split(",").length;
            });

            return total;
        },

        /**
         * toggleFilters
         *
         * Description: Either add or remove the filter term from
         * it's taxonomy.
         *
         * @param {string} term
         * @param {string} filterName
         * @param {string} type
         * @return void
         */
        toggleFilters(term = "", filterName = "", type = "taxonomy") {
            const filter = this.getPrefixedFilter(filterName, type);

            // If this is the first filter to be added, just add it.
            if (typeof this.currentFilters[filter] === "undefined") {
                this.currentFilters[filter] = term;

                // Refresh the post grid content
                this.fetchContent();
                return;
            }

            // If we have filters for the current filter, check if the term is already in the list.
            if (this.currentFilters[filter].length) {
                if (this.currentFilters[filter].includes(term)) {
                    // If the term is already in the list, remove it from the filter.
                    this.currentFilters[filter] = this.removeFilter(
                        filter,
                        term
                    );
                    // If this filter filter is now empty, remove it from the current filters.
                    if (!this.currentFilters[filter].length) {
                        delete this.currentFilters[filter];
                    }
                } else {
                    // If the term is not already in the list, add it.
                    this.currentFilters[filter] += "," + term;
                }
            } else {
                // If there isn't a filter for this filter, add it and then add the term to it.
                this.currentFilters[filter] = term;
            }

            // Refresh the post grid content
            if (fetch) {
                this.fetchContent();
            }
        },

        /**
         * removeFilter
         *
         * Description: Removes a given term from it's taxonomy filter.
         *
         * @param {string} filter
         * @param {string} value
         * @return string
         */
        removeFilter(filter, value) {
            // Get the filter values from the currentFilters array
            const filterValue = this.currentFilters[filter];

            // Turn the filter values into an array
            const filterValueArray = filterValue.split(",");

            // Loop through the array and remove the given value
            for (let i = 0; i < filterValueArray.length; i++) {
                if (filterValueArray[i] === value) {
                    filterValueArray.splice(i, 1);
                }
            }

            // Return the array as a string
            return filterValueArray.toString();
        },

        /**
         * clearFilters
         *
         * Description: Empty the current filters and refresh the page.
         *
         * @return void
         */
        clearFilters() {
            this.currentFilters = {};
            window.location.href =
                window.location.protocol +
                "//" +
                window.location.hostname +
                window.location.pathname;
        },

        /**
         * fetchContent
         *
         * Description: Requests the new post grid based on the current
         * filters and replaces the current post grid with it's content.
         *
         * @param {string} href
         * @return void
         */
        fetchContent(href = null, updateMarkers = true) {
            // Get the post grid container and the data selector for the post grid.
            const postGrid = this.postGrid.querySelector(
                "[data-pegasus-filterable]"
            );
            const elements = [
                'data-pegasus-filterable="' +
                    postGrid.dataset.pegasusFilterable +
                    '"',
            ];
            let currentUrl = "";

            // If there are no filters, just refresh the page.
            if (!Object.keys(this.currentFilters).length) {
                if (href) {
                    currentUrl = href;
                } else {
                    window.location.href =
                        window.location.protocol +
                        "//" +
                        window.location.hostname +
                        window.location.pathname;
                    return;
                }
            } else {
                // If there are filters, build the url and set it as the current url.
                currentUrl = this.buildUrl();
            }

            // If a href is passed in, use that instead of the current url.
            if (href) {
                currentUrl = href;
            }

            // Only allow a request to happen whilst we're not waiting for a response.
            if (!this.isLoading) {
                this.isLoading = true;

                // Run the ajaxContent function from pegasus.
                pegasus.ajaxContent(currentUrl, elements, {}, () => {
                    this.isLoading = false;

                    // Update the url with the current filters.
                    history.pushState(
                        JSON.stringify(this.currentFilters),
                        "",
                        currentUrl
                    );

                    if (
                        updateMarkers &&
                        typeof window.mapComponent !== "undefined"
                    ) {
                        window.mapComponent.updateMarkers(true);
                    }

                    // Scroll to the top of the post grid.
                    pegasus.scroll(this.postGrid);

                    // If the post grid items open in modals make sure to re-initialise them.
                    if (typeof window.modal !== "undefined") {
                        window.modal.init();
                    }
                });
            }
        },

        /**
         * getCurrentFilters
         *
         * Description: Get the current filters from the url.
         *
         * @return object
         */
        getCurrentFilters() {
            // Get the current url and parse the query string.
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            let currentFilters = {};

            // Loop through the query string and add each filter to the currentFilters object.
            for (const [key, value] of params.entries()) {
                currentFilters[key] = value;
            }

            return currentFilters;
        },

        /**
         * filterIsActive
         *
         * Description: Checks if a given filter is currently selected.
         *
         * @param {string} filter
         * @param {string} term
         * @param {string} type
         * @return {boolean}
         */
        filterIsActive(term, filter, type = "taxonomy") {
            const filterName = this.getPrefixedFilter(filter, type);
            if (typeof this.currentFilters[filterName] !== "undefined") {
                return this.currentFilters[filterName].includes(term);
            }
            return false;
        },

        /**
         * buildUrl
         *
         * Description: Build the URL to request from based on the current filters.
         *
         * @return void
         */
        buildUrl() {
            // Set the URL to the current page.
            let url =
                window.location.protocol +
                "//" +
                window.location.hostname +
                window.location.pathname +
                "?";
            let i = 1;

            // Loop through the filters and add them to the URL
            for (const [key, value] of Object.entries(this.currentFilters)) {
                url += `${key}=${value}`;
                if (i < Object.keys(this.currentFilters).length) {
                    url += "&";
                }
                i++;
            }

            return url;
        },

        /**
         * loadMore
         *
         * Description: Loads the next page of posts below the current set of posts.
         * @return void
         */
        loadMore() {
            // Get the post grid container and the data selector for the post grid.
            const postGrid = this.$root.querySelector(
                "[data-pegasus-filterable]"
            );
            const dataSelector =
                '[data-pegasus-filterable="' +
                postGrid.dataset.pegasusFilterable +
                '"]';

            // Get the url for the next page of posts. This is taken from the href of the load more button.
            const href = this.$el.getAttribute("href");

            // Get the container and elements to be loaded from the next page.
            const container = [dataSelector];
            const elements = [
                "[data-pegasus-single-card]",
                ".Post__Grid-next-page",
            ];

            // Only allow the load more button to be clicked whilst we're not waiting for a response.
            if (!this.isLoading) {
                this.isLoading = true;

                // Run the loadMoreContent function from pegasus.
                pegasus.loadMoreContent(href, container, elements, {}, () => {
                    this.isLoading = false;

                    // Remove the load more button from the original page,
                    // keeping only the one that comes back from the request.
                    this.$el.parentElement.remove();
                });
            }
        },

        /**
         * fetchPage
         *
         * Description: Gets the requested page of posts based on the
         * link selected in the pagination.
         *
         * @param {string} href
         * @return void
         */
        fetchPage(href = null) {
            // Get the post grid container and the data selector for the post grid.
            const postGrid = this.$root.querySelector(
                "[data-pegasus-filterable]"
            );
            const elements = [
                'data-pegasus-filterable="' +
                    postGrid.dataset.pegasusFilterable +
                    '"',
            ];

            // Only allow a request to happen whilst we're not waiting for a response.
            if (!this.isLoading) {
                this.isLoading = true;

                // Run the ajaxContent function from pegasus.
                pegasus.ajaxContent(href, elements, {}, () => {
                    this.isLoading = false;

                    // Update the url with the current filters.
                    history.pushState("", "", href);

                    pegasus.scroll(postGrid);

                    // If the post grid items open in modals make sure to re-initialise them.
                    if (typeof window.modal !== "undefined") {
                        window.modal.init();
                    }
                });
            }
        },

        /**
         * getPrefixedFilter
         * @param {string} filter
         * @param {string} type
         * @return {string}
         */
        getPrefixedFilter(filter, type = "taxonomy") {
            return `${this.filterPrefix[type]}${filter}`;
        },
    }));
});
